export const exists = (value: any) => {
    return Boolean(value);
};
